import React from "react";

import {
  TimelineMax,
  TweenMax,
  TweenLite,
  Linear,
  TextPlugin,
  ThrowPropsPlugin,
  EasePack,
  CSSPlugin,
  ScrollToPlugin,
  Power1,
  Power2,
  Power3,
  Power4,
  Expo,
  gsap,
} from "gsap";

import { Slide, Fade } from "react-slideshow-image";
import "react-slideshow-image/dist/styles.css";

import artistsData, { defaultData as defaultArtistData } from "../data/art";

const properties = {
  duration: 5000,
  transitionDuration: 300,
  infinite: true,
  canSwipe: true,
  indicators: true,
  prevArrow: (
    <div className="slide_nav prev">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        className="arrow"
        fill="#fff"
      >
        <path d="M5.25514 11.0138H15.7106L10.9124 6.21565L12.1281 5L19.001 11.8729L12.1281 18.7458L10.9124 17.5302L15.7106 12.732H5.25514V11.0138Z"></path>
      </svg>
    </div>
  ),
  nextArrow: (
    <div className="slide_nav next">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        className="arrow"
        fill="#fff"
      >
        <path d="M5.25514 11.0138H15.7106L10.9124 6.21565L12.1281 5L19.001 11.8729L12.1281 18.7458L10.9124 17.5302L15.7106 12.732H5.25514V11.0138Z"></path>
      </svg>
    </div>
  ),
  // indicators: (i) => <div className="indicator">{i + 1}</div>,
};

const ArtistModal = (props) => {
  const index = props.activeArtistIndex;
  const data = index !== null ? artistsData[index] : defaultArtistData;

  // gsap.to(".artwork_inner_cover", {
  //   opacity: 1,
  //   duration: 0.3,
  //   ease: Power2.easeOut,
  // });
  // gsap.to(".artwork_inner_close_btn", {
  //   opacity: 1,
  //   duration: 0.3,
  //   ease: Power2.easeOut,
  // });

  return (
    <div className="artwork_inner_wrapper">
      <div
        className="artwork_inner_close_btn"
        onClick={() => props.setActiveArtistIndex(null)}
      >
        ✕
      </div>
      <div className="artwork_inner_cover">
        <div className="artwork_content">
          <div className="slide_wrap">
            <div className="slide-container">
              <Fade {...properties}>
                {data.img.map((url, index) => (
                  <div className="each-fade" key={index}>
                    <div className="image-container">
                      <img src={url} />
                    </div>
                  </div>
                ))}
              </Fade>
            </div>
          </div>
          <div className="content_wrap">
            <div className="row_area_m">
              <div className="col_1">
                <div className="col_box col_sticky">
                  <h3 className="section_main_title">
                    {data.title_zh}
                    <div className="en">{data.title_en}</div>
                  </h3>
                  <p className="tag_list">{data.tag_zh}<br />{data.tag_en}</p>
                </div>
              </div>
              <div className="col_2">
                <div className="inner_article">
                  <div
                    dangerouslySetInnerHTML={{ __html: data.intro_zh }}
                    className="context"
                  />
                  <div
                    dangerouslySetInnerHTML={{ __html: data.intro_en }}
                    className="context"
                  />
                </div>
              </div>
            </div>

            <div className="row_area_m">
              <div className="col_1">
                <div className="col_box col_sticky">
                  <h3 className="art_author">
                    <div className="zh">{data.author_zh}</div>
                    <div className="en">{data.author_en}</div>
                  </h3>
                </div>
              </div>
              <div className="col_2">
                <div className="inner_article">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: data.author_intro_zh,
                    }}
                    className="context"
                  />
                  <div
                    dangerouslySetInnerHTML={{
                      __html: data.author_intro_en,
                    }}
                    className="context"
                  />
                  {data.q1_zh != "" ? (
                    <div className="qa_box">
                      <h4>
                        Q1 假如綠島是一面鏡子
                        <br />
                        If Green Island were a mirror…
                      </h4>
                      <div dangerouslySetInnerHTML={{ __html: data.q1_zh }} />
                      <div dangerouslySetInnerHTML={{ __html: data.q1_en }} />
                      <br />
                      <h4>
                        Q2 人權對你來說是什麼
                        <br />
                        What is human rights to you…
                      </h4>
                      <div dangerouslySetInnerHTML={{ __html: data.q2_zh }} />
                      <div dangerouslySetInnerHTML={{ __html: data.q2_en }} />
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArtistModal;
